export default __webpack_public_path__ + "static/media/avatar.c9034bb5.png";